import { useCallback,useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { api } from '../services';
import { payApi } from '../services/payApi';
import moment from 'moment-jalaali';
import {
  setPaymentData,
  setWalletBalance,
  setPaymentSuccessful,
  setPageLocked,
  setLoading,
  setError,
  setAuthority,
  resetPaymentState
} from '../store/slices/paymentSlice';
// import { setUserData } from '../store/slices/authSlice';
import { useNavigate } from 'react-router-dom';

// Helper to format time as HH:mm:ss
function formatTimeToHHMMSS(timeStr) {
  if (!timeStr) return '';
  const parts = timeStr.split(':');
  const hour = parts[0]?.padStart(2, '0') || '00';
  const minute = parts[1]?.padStart(2, '0') || '00';
  const second = parts[2]?.padStart(2, '0') || '00';
  return `${hour}:${minute}:${second}`;
}

export const usePayment = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
    const OID = useMemo(() => (process.env.REACT_APP_OID || '1'), []);
  const {
    paymentData,
    walletBalance,
    isLoading,
    error
  } = useSelector((state) => state.payment);
  
  const { key } = useSelector((state) => state.auth);

  const fetchUserData = useCallback(async () => {
    try {
      if (!key) {
        console.error('Authentication key is missing');
        throw new Error('No authentication key found');
      }
      console.log('Fetching user data with key:', key);
      const response = await api.get(`Home/GetProfileInfo?SesID=${key}&OID=1`);
      console.log('API Response:', response);
      let data = response.data;
      console.log('Response data:', data);
      
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
          console.log('Parsed JSON data:', data);
        } catch (error) {
          console.error('Failed to parse JSON:', error);
          return null;
        }
      }
      
      if (!data || !data[0]) {
        console.error('Invalid data structure received:', data);
        throw new Error('No user data received');
      }
      
      // Set wallet balance in Redux store
      const balance = data[0]?.Bedehi || 0;
      dispatch(setWalletBalance(Math.abs(balance))); // Convert negative to positive
      
      return data;
    } catch (error) {
      console.error('Error in fetchUserData:', error);
      throw error;
    }
  }, [key, dispatch]);

  const fetchDoctorServices = useCallback(async (doctorId) => {
    try {
      if (!doctorId) {
        throw new Error('No doctor ID provided');
      }
      const response = await api.get(
        `Home/GetServiceDoctor?OID=1&doctorId=${doctorId}`,
      );
      let data = response.data;
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (error) {
          return null;
        }
      }
      if (!data || !Array.isArray(data)) {
        throw new Error('Invalid doctor services data received');
      }
      const filteredServices = data.filter((item) => item.OnlineTurning === 1);
      if (filteredServices.length === 1) {
        return filteredServices[0];
      }
      return null;
    } catch (error) {
      throw error;
    }
  }, []);

  const buildAppointmentDescription = useCallback((servicePrice) => {
    const description = [
      `Appointment Type: ${paymentData.serviceCategoryName || 'Unknown'}`,
      `Doctor: ${paymentData.doctorName || ''} ${paymentData.doctorFamil || ''}`,
      `Appointment Date: ${paymentData.dateSelected || 'Unknown'}`,
      `Appointment Time: ${paymentData.timeSelected || 'Unknown'}`,
      `Appointment Number: ${paymentData.num || 'Unknown'}`,
      `Patient Name: ${paymentData.patientName || 'Unknown'}`,
      `Amount: ${paymentData.price || servicePrice || 0} Rials`,
      `Service Category ID: ${paymentData.serviceCategoryId || 'Unknown'}`,
      `Doctor ID: ${paymentData.doctorId || 'Unknown'}`,
      `Patient ID: ${paymentData.patientId || 'Unknown'}`,
      `Service Doctor ID: ${paymentData.serviceDoctorId || 'Unknown'}`
    ].join(' | ');
    
    return description;
  }, [paymentData]);

  const parseDescriptionFromURL = useCallback((descParam) => {
    try {
      if (!descParam) {
        console.warn('No desc parameter provided');
        return null;
      }

      // Decode URL-encoded string
      const decodedDesc = decodeURIComponent(descParam);
      console.log('Decoded description:', decodedDesc);

      // Split by | to get individual fields
      const fields = decodedDesc.split(' | ');
      
      // Parse each field into key-value pairs
      const parsedData = {};
      
      fields.forEach(field => {
        const colonIndex = field.indexOf(':');
        if (colonIndex !== -1) {
          const key = field.substring(0, colonIndex).trim();
          const value = field.substring(colonIndex + 1).trim();
          parsedData[key] = value;
        }
      });

      console.log('Parsed appointment data:', parsedData);
      return parsedData;
    } catch (error) {
      console.error('Error parsing description from URL:', error);
      return null;
    }
  }, []);

  const handlePayment = useCallback(async (servicePrice) => {
    if (!servicePrice) return;
    
    try {
      dispatch(setLoading(true));
      
      // Build description string with all appointment information
      const descriptioncl = buildAppointmentDescription(servicePrice);
      
      console.log('Payment request with description:', {
        amount: servicePrice,
        descriptioncl: descriptioncl
      });
      
      const res = await payApi.post('Home/Request', {
        amount: servicePrice,
        descriptioncl: descriptioncl
      });
      const { paymentURL, authority } = res.data;
      dispatch(setAuthority(authority));
      dispatch(setPaymentData({ price: servicePrice }));
      window.location.href = paymentURL;
    } catch (error) {
      console.error('Error initiating payment:', error);
      dispatch(setError(error.response?.data?.ErrorMessage || 'خطا در شروع پرداخت'));
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }, [dispatch, buildAppointmentDescription]);

   const baseUrlCRM = process.env.REACT_APP_CRMFILE_SERVER;
     //برای ثبت درخواست این توابع اضافه شده 
          const fetchProfile = async () => {
            try {
              const response = await api.get(`Home/GetProfileInfo?SesID=${key}&OID=${OID}`);
              let data = response.data;
      
              if (typeof data === 'string') {
                try {
                  data = JSON.parse(data);
                } catch (error) {
                  console.error('Invalid JSON string:', data);
                  
                  return;
                }
              }
      
              if (Array.isArray(data) && data.length > 0) {
                localStorage.setItem('patientID', data[0].PatientID);
                if (!data[0].Melicode) {
                  navigate('/edirPro');
                }
                return data;
                
              } else {
                 console.error('اطلاعات پروفایل یافت نشد');
               
              }
            } catch (error) {
              console.error('Error fetching profile:', error);
            
            }
          };
    
      const searchPatient = async (mobile) => {
        try {
          const response = await fetch(
            `${baseUrlCRM}api/doapi?apikey=${process.env.REACT_APP_API_KEY}&func=SearchBimar&Mobile=${mobile}`,
            {
              method: 'GET',
              headers: {
                Accept: 'application/json',
              },
            }
          );
    
          const text = await response.text();
          let data;
          try {
            data = JSON.parse(text);
          } catch (error) {
            console.error('Invalid JSON response from SearchBimar:', text);
            throw new Error('پاسخ سرور نامعتبر است');
          }
    
          return data;
        } catch (error) {
          console.error('Error searching patient:', error);
          throw error;
        }
      };
  
      const GetVaziatByCode = async (code) => {
        try {
          const response = await fetch(
            `${baseUrlCRM}api/doapi?apikey=${process.env.REACT_APP_API_KEY}&func=GetVaziatByCode&vcode=${code}`,
            {
              method: 'GET',
              headers: {
                Accept: 'application/json',
              },
            }
          );
    
          const text = await response.text();
          let data;
          try {
            data = JSON.parse(text);
          } catch (error) {
            console.error('Invalid JSON response from SearchBimar:', text);
            throw new Error('پاسخ سرور نامعتبر است');
          }
    
          return data;
        } catch (error) {
          console.error('Error searching patient:', error);
          throw error;
        }
      };
  
    
      const insertPatient = async (profile) => {
        try {
          const params = new URLSearchParams({
            apikey: process.env.REACT_APP_API_KEY,
            func: 'InsertBimar',
            userid: '6',
            Fname: profile.Fname,
            Lname: profile.Lname,
            CodeMelli: profile.Melicode || '',
            FileNo: profile.PatientFileNo.toString(),
            Mobile: profile.Mobile,
            FatherName: '-',
          });
    
          const response = await fetch(
            `${baseUrlCRM}api/Doupdateapi?${params.toString()}`,
            {
              method: 'GET',
            }
          );
    
          const text = await response.text();
          let data;
          try {
            data = JSON.parse(text);
          } catch (error) {
            console.error('Invalid JSON response from InsertBimar:', text);
            throw new Error('پاسخ سرور نامعتبر است');
          }
    
          if (data && data.id) {
            return data.id;
          } else {
            throw new Error('ثبت بیمار ناموفق بود');
          }
        } catch (error) {
          console.error('Error inserting patient:', error);
          throw error;
        }
      };
    
      const insertRequest = async (ccid, question, description,VaziatCode) => {
        try {
           const now = moment();
          const persianDate = now.format('jYYYY/jMM/jDD');
    
          const requestDesc = `${question}: ${description}`;
          const params = new URLSearchParams({
            apikey: process.env.REACT_APP_API_KEY,
            func: 'InsertRequest',
            userid: '36400',
            BimarID: ccid,
            SabtDate: persianDate,
            RequestDesc: requestDesc,
            Vaziat: VaziatCode
          });
    
          const response = await fetch(
            `${baseUrlCRM}api/Doupdateapi?${params.toString()}`,
            {
              method: 'GET',
            }
          );
    
          const text = await response.text();
          let data;
          try {
            data = JSON.parse(text);
          } catch (error) {
            console.error('Invalid JSON response from InsertRequest:', text);
            throw new Error('پاسخ سرور نامعتبر است');
          }
    
          if (data && data.id) {
            return data.id;
          } else {
            throw new Error('ثبت درخواست ناموفق بود');
          }
        } catch (error) {
          console.error('Error inserting request:', error);
          throw error;
        }
      };
      const insertRequestPayment = async (ccid, price, rahgiri,paydate,description) => {
        try {
           const now = moment();
          const persianDate = now.format('jYYYY/jMM/jDD');
    
          const requestDesc = ` ${description}`;
          const params = new URLSearchParams({
            apikey: process.env.REACT_APP_API_KEY,
            func: 'InsertVariz',
            userid: '36400',
            pccid: ccid,
            PayDate: paydate,
            Description: requestDesc,
            Price:price,
            Rahgiri:rahgiri,
  
          });
    
          const response = await fetch(
            `${baseUrlCRM}api/Doupdateapi?${params.toString()}`,
            {
              method: 'GET',
            }
          );
    
          const text = await response.text();
          let data;
          try {
            data = JSON.parse(text);
          } catch (error) {
            console.error('Invalid JSON response from InsertRequest:', text);
            throw new Error('پاسخ سرور نامعتبر است');
          }
    
          if (data && data.id) {
            return data.id;
          } else {
            throw new Error('ثبت واریز درخواست ناموفق بود');
          }
        } catch (error) {
          console.error('Error inserting request:', error);
          throw error;
        }
      };
       
      //پایان توابع ثبت درخواست 

  const handleWalletPayment = useCallback(async () => {
    console.log('Wallet Balance:', walletBalance, typeof walletBalance); // Log wallet balance and type
    console.log('Purchase Price:', paymentData.price, typeof paymentData.price); // Log purchase price and type
    const price = Number(paymentData.price);
     const ServiceCategoryID = localStorage.getItem('ServiceCategoryID') || '';
    if (walletBalance < price) {
      dispatch(setError('موجودی کیف پول کافی نیست'));
      throw new Error('موجودی کیف پول کافی نیست');
    }
    
    try {
      dispatch(setLoading(true));
      const userData = await fetchUserData();
      const doctorService = await fetchDoctorServices(paymentData.doctorId);
      if(ServiceCategoryID==='48'){
      }else{
      if (!userData || !doctorService) {
        throw new Error('اطلاعات کاربر یا پزشک یافت نشد');
      }
    }
      const gregorianDate = moment(paymentData.dateSelected, 'jYYYY/jMM/jDD')
        .format('YYYY-MM-DD')
        .split('-');
      const formattedDate = moment().format('MM/DD/YYYY HH:mm:ss');
      const resultTime = `${gregorianDate[1]}/${gregorianDate[2]}/${gregorianDate[0]}`;

      // Debug payload for SabtNobat (wallet)
      const sabtNobatParamsWallet = {
        SesID: key,
        OID: 1,
        PatientID: userData[0]?.PatientID,
        ServiceDoctorID: doctorService?.ID,
        NobatNumber: paymentData.num,
        timadate: formatTimeToHHMMSS(paymentData.timeSelected),
        Date: resultTime,
        TransactionNum: 'wallet',
        sabtdate: formattedDate
      };
      
       if(ServiceCategoryID==='48'){
              // جستجوی بیمار با شماره موبایل
      const temprequestid=localStorage.getItem('requestid') || '';
      if(temprequestid===''){
          const profile=await fetchProfile();
          console.log(profile);
      let patientID = userData[0]?.PatientID;
      const searchResult = await searchPatient(profile[0].Mobile);
  
      if (searchResult.length === 0) {
        patientID = await insertPatient(profile[0]);
      } else if (searchResult[0].ccid) {
        patientID = searchResult[0].ccid;
      } else {
        console.log('خطا در جستجوی بیمار');
       dispatch(setError('خطا در جستجوی بیمار'));
        throw new Error('خطا در جستجوی بیمار');
        
      }
      const VaziatData=await GetVaziatByCode('104');
      let vaziatccid=0;
      if(VaziatData.length>0){
           vaziatccid=VaziatData[0].ccid;
       
      }
  
      // ثبت درخواست
      const requestId = await insertRequest(patientID, '','',vaziatccid);
      localStorage.setItem("requestid",requestId);
       const now = moment();
          const persianDate = now.format('jYYYY/jMM/jDD');

      const varizid=await insertRequestPayment(requestId,price,'wallet',formatTimeToHHMMSS(paymentData.timeSelected),'واریز کاربر جهت مشاوره غیر حضوری');
       console.log(varizid);
      const walletapi = await api.get(`Home/DecreaseBedehi?SesID=${key}&OID=${OID}&Amount=${price}`);
      
       console.log(walletapi); 
      }
       }else{
      const sabtNobatUrlWallet = `Home/SabtNobat?SesID=${key}&OID=1&PatientID=${userData[0]?.PatientID}&ServiceDoctorID=${doctorService?.ID}&NobatNumber=${paymentData.num}&timadate=${formatTimeToHHMMSS(paymentData.timeSelected)}&Date=${resultTime}&TransactionNum=wallet&sabtdate=${formattedDate}`;
      console.log('WebService Debug Payload → SabtNobat (wallet)', {
        method: 'GET',
        endpoint: 'Home/SabtNobat',
        params: sabtNobatParamsWallet,
        url: sabtNobatUrlWallet
      });
      try { localStorage.setItem('lastSabtNobatUrl', sabtNobatUrlWallet); } catch (_) {}
      window.__WS_DEBUG = {
        ...(window.__WS_DEBUG || {}),
        lastSabtNobatWallet: {
          method: 'GET',
          endpoint: 'Home/SabtNobat',
          params: sabtNobatParamsWallet,
          url: sabtNobatUrlWallet
        }
      };
      const response = await api.get(sabtNobatUrlWallet);

      if (response.data?.ErrorMessage) {
        dispatch(setError(response.data.ErrorMessage));
        throw new Error(response.data.ErrorMessage);
      }
    }
      dispatch(setPaymentSuccessful(true));
      dispatch(setPageLocked(true));
      dispatch(setWalletBalance(walletBalance - price));
      dispatch(resetPaymentState());
      
      return true;
    } catch (error) {
      console.error('Error processing wallet payment:', error);
      dispatch(setError(error.message || 'خطا در پرداخت با کیف پول یا رزرو نوبت'));
      throw error;
    } finally {
      dispatch(setLoading(false));
      console.log("finally of usepayment");
    }
  }, [dispatch, key, paymentData, walletBalance, fetchUserData, fetchDoctorServices]);

  const verifyPayment = useCallback(async (authority, descParam = null) => {
    try {
      dispatch(setLoading(true));
      
      // Read params from URL if not explicitly provided
      const searchParams = new URLSearchParams(window.location.search);
      const resolvedAuthority = authority || searchParams.get('Authority') || searchParams.get('authority');
      const resolvedDescParam = descParam ?? searchParams.get('desc') ?? searchParams.get('Desc');

      // Parse description from URL if provided
      let parsedAppointmentData = null;
      if (resolvedDescParam) {
        parsedAppointmentData = parseDescriptionFromURL(resolvedDescParam);
        console.log('Using parsed appointment data from URL:', parsedAppointmentData);
      }

      const userData = await fetchUserData();
      
      // Use parsed data or fallback to paymentData (kept for clarity, not used directly)
      // const appointmentData = parsedAppointmentData || paymentData;
      
      // Extract doctor name from parsed data
      let doctorName = '';
      let doctorFamil = '';
      if (parsedAppointmentData && parsedAppointmentData['Doctor']) {
        const doctorFullName = parsedAppointmentData['Doctor'].trim();
        const nameParts = doctorFullName.split(' ');
        if (nameParts.length >= 2) {
          doctorFamil = nameParts[0]; // First part as family name
          doctorName = nameParts.slice(1).join(' '); // Rest as given name
        } else {
          doctorName = doctorFullName;
        }
      } else {
        doctorName = paymentData.doctorName || '';
        doctorFamil = paymentData.doctorFamil || '';
      }

      // Get service doctor ID from parsed data or fallback
      const serviceDoctorId = parsedAppointmentData?.['Service Doctor ID'] || 
                             parsedAppointmentData?.['ServiceDoctorID'] || 
                             paymentData.serviceDoctorId;
      
      const doctorId = parsedAppointmentData?.['Doctor ID'] || paymentData.doctorId;
      
      // Fetch doctor service if we have the ID
      let doctorService = null;
      if (doctorId) {
        doctorService = await fetchDoctorServices(doctorId);
      }
      
      if (!userData) {
        throw new Error('اطلاعات کاربر یافت نشد');
      }

      // Use appointment data from parsed description or fallback
      const appointmentDate = parsedAppointmentData?.['Appointment Date'] || paymentData.dateSelected;
      const appointmentTime = parsedAppointmentData?.['Appointment Time'] || paymentData.timeSelected;
      const appointmentNumber = parsedAppointmentData?.['Appointment Number'] || paymentData.num;
      const patientName = parsedAppointmentData?.['Patient Name'] || paymentData.patientName;
      const amount = parsedAppointmentData?.['Amount']?.replace(' Rials', '') || paymentData.price;
      const serviceCategoryName = parsedAppointmentData?.['Appointment Type'] || paymentData.serviceCategoryName;
      const patientId = parsedAppointmentData?.['Patient ID'] || paymentData.patientId;

      if (!appointmentDate || !appointmentTime || !appointmentNumber) {
         console.log(appointmentDate+'&&'+appointmentTime+'&&'+appointmentNumber);
        throw new Error('اطلاعات نوبت ناقص است'+appointmentDate+'&&'+appointmentTime+'&&'+appointmentNumber);
      }

      const gregorianDate = moment(appointmentDate, 'jYYYY/jMM/jDD')
        .format('YYYY-MM-DD')
        .split('-');
      const formattedDate = moment().format('MM/DD/YYYY HH:mm:ss');
      const resultTime = `${gregorianDate[1]}/${gregorianDate[2]}/${gregorianDate[0]}`;

      // Use service doctor ID from parsed data or doctor service
      const finalServiceDoctorId = serviceDoctorId || doctorService?.ID;
      
      if (!finalServiceDoctorId) {
        throw new Error('شناسه سرویس پزشک یافت نشد');
      }

      // Debug payload for SabtNobat (verifyPayment)
      const sabtNobatParamsVerify = {
        SesID: key,
        OID: 1,
        PatientID: patientId,
        ServiceDoctorID: finalServiceDoctorId,
        NobatNumber: appointmentNumber,
        timadate: formatTimeToHHMMSS(appointmentTime),
        Date: resultTime,
        TransactionNum: resolvedAuthority,
        sabtdate: formattedDate
      };
      const sabtNobatUrlVerify = `Home/SabtNobat?SesID=${key}&OID=1&PatientID=${patientId}&ServiceDoctorID=${finalServiceDoctorId}&NobatNumber=${appointmentNumber}&timadate=${formatTimeToHHMMSS(appointmentTime)}&Date=${resultTime}&TransactionNum=${resolvedAuthority}&sabtdate=${formattedDate}`;
      console.log('WebService Debug Payload → SabtNobat (verifyPayment)', {
        method: 'GET',
        endpoint: 'Home/SabtNobat',
        params: sabtNobatParamsVerify,
        url: sabtNobatUrlVerify
      });
      try { localStorage.setItem('lastSabtNobatUrl', sabtNobatUrlVerify); } catch (_) {}
      window.__WS_DEBUG = {
        ...(window.__WS_DEBUG || {}),
        lastSabtNobatVerify: {
          method: 'GET',
          endpoint: 'Home/SabtNobat',
          params: sabtNobatParamsVerify,
          url: sabtNobatUrlVerify
        }
      };
      const response = await api.get(sabtNobatUrlVerify);
      
      if (response.data?.ErrorMessage) {
        dispatch(setError(response.data.ErrorMessage));
        throw new Error(response.data.ErrorMessage);
      }
      
      await payApi.post('/Home/Verify', {
        amount: amount,
        authority: resolvedAuthority,
      });
      
      dispatch(setPaymentSuccessful(true));
      dispatch(setAuthority(resolvedAuthority));
      
      // Update payment data with parsed information
      const updatedPaymentData = {
        serviceCategoryName: serviceCategoryName,
        doctorName: doctorName,
        doctorFamil: doctorFamil,
        dateSelected: appointmentDate,
        timeSelected: appointmentTime,
        patientName: patientName,
        price: amount,
        serviceDoctorId: finalServiceDoctorId,
        doctorId: doctorId,
        patientId: patientId,
        num: appointmentNumber
      };
      
      dispatch(setPaymentData(updatedPaymentData));
      
      // Save complete invoice data
      const invoiceData = {
        CategoryName: serviceCategoryName,
        doctorName: doctorName,
        doctorFamil: doctorFamil,
        appointmentDate: appointmentDate,
        appointmentTime: appointmentTime,
        patientName: patientName,
        paymentAmount: amount,
        paymentTime: formattedDate,
        authority: resolvedAuthority,
        serviceDoctorId: finalServiceDoctorId,
        doctorId: doctorId,
        patientId: patientId,
        appointmentNumber: appointmentNumber
      };
      
      localStorage.setItem('isPaymentSuccessful', 'true');
      localStorage.setItem('authority', authority);
      localStorage.setItem('invoiceData', JSON.stringify(invoiceData));
      
      console.log('Payment verified successfully with parsed data:', invoiceData);
      
      navigate('/PaymentReceipt');
      return true;
    } catch (error) {
      console.error('Error in verifyPayment:', error);
      dispatch(setError(error.message || 'خطا در تأیید پرداخت یا رزرو نوبت'));
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  }, [dispatch, key, paymentData, fetchUserData, fetchDoctorServices, navigate, parseDescriptionFromURL]);

  return {
    isLoading,
    error,
    handlePayment,
    handleWalletPayment,
    verifyPayment,
    fetchUserData,
    fetchDoctorServices,
    parseDescriptionFromURL
  };
};